<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-shield-check icon"></i>
        <span>Pré-autorizações</span>
      </h1>
      <router-link :to="{ name: 'preAuthorizationCreate' }">
        <PrimaryButton class="px-5" icon="fa-solid fa-solid fa-plus">Nova pré-autorização</PrimaryButton>
      </router-link>
    </div>
  </div>


  <div class="align p-4 space_title">

    <div v-if="!loading || preAuthorizations.data" class="card">
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Título</th>
            <th>Status</th>
            <th>Data</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(preAuthorization, key) in preAuthorizations.data" :key="key">
            <td>
              {{ preAuthorization.id }}
            </td>
            <td>
              {{ preAuthorization.title }}
            </td>
            <td>
              <span class="badge" :style="'background-color: ' + preAuthorization.status_color">{{ preAuthorization.status_name }}</span>
            </td>
            <td>
              {{ $dateFormat(preAuthorization.created_at) }}
            </td>
            <td class="actions">
                <router-link :to="{ name: 'preAuthorization', params: { id: preAuthorization.id }}">
                  <button class="btn btn-secondary" type="button">
                    <i class="fa-regular fa-edit"></i>
                  </button>
                </router-link>
            </td>
          </tr>
          <tr class="no_result" v-if="!preAuthorizations.data || (preAuthorizations.data && !preAuthorizations.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>


    <ListPagination class="mt-4" :links="preAuthorizations.meta.links" />
  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { usePreAuthorizationStore } from '@/stores/PreAuthorizationStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute } from 'vue-router';

const loader = inject('$loader');
const loading = ref(false);

const route = useRoute();
const preAuthorizationStore = usePreAuthorizationStore();
const { preAuthorizations, filter } = storeToRefs(preAuthorizationStore);


onBeforeMount(() => {
  loadPreAuthorizations();
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadPreAuthorizations();
  }
});

async function loadPreAuthorizations() {
  loader.show();
  loading.value = true;

  filter.value.page = parseInt(route.query.page);
  filter.value.limit = 10;

  await preAuthorizationStore.getPreAuthorizations();
  loader.hide();
  loading.value = false;
}
</script>